import { render, staticRenderFns } from "./SolutionDialogItem.vue?vue&type=template&id=5bb78656&"
import script from "./SolutionDialogItem.vue?vue&type=script&lang=ts&"
export * from "./SolutionDialogItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports